<template>
  <div
    class="account-pane account-main"
    :class="{ active: active }"
    data-account-pane="complete-profile"
  >
    <div class="heading">
      <h3 class="greeting wt-sb font-lg text-center">
        Thanks for taking the next steps to complete your profile,
        {{ user.first_name }}
      </h3>
      <!-- <span
        class="tags tags-mobile"
        v-if="!$store.getters['user/stripeConnectIsOnboarded']"
      >
        <span class="alert-tag error"
          >Please complete your payment details</span
        >
      </span> -->
    </div>
    <div class="account-nav-container">
      <internal-nav
        class="account-nav"
        :active-item="activeNavItem"
        :items="navItems"
        :interactive="false"
        @select="changePage"
      ></internal-nav>
    </div>
    <div id="account-profile-pages" class="account-content">
      <vue-simplebar class="account-pages container">
        <complete-profile-details-page></complete-profile-details-page>
        <complete-profile-company-page></complete-profile-company-page>
        <lister-complete-profile-payment-page></lister-complete-profile-payment-page>
        <lister-complete-profile-complete-page></lister-complete-profile-complete-page>
      </vue-simplebar>
    </div>
    <div class="pane-footer"></div>
  </div>
</template>

<script>
import AccountPane from "../../AccountPane";
import CompleteProfileDetailsPage from "../../shared/panels/complete-profile/AccountDetails";
import CompleteProfileCompanyPage from "../../shared/panels/complete-profile/CompanyDetails";
import ListerCompleteProfilePaymentPage from "./complete-profile/Payment";
import ListerCompleteProfileCompletePage from "./complete-profile/Complete";

export default {
  extends: AccountPane,
  components: {
    CompleteProfileDetailsPage,
    CompleteProfileCompanyPage,
    ListerCompleteProfilePaymentPage,
    ListerCompleteProfileCompletePage,
  },
  data() {
    return {
      id: "complete-profile",
      page: "profile-details",
    };
  },
  mounted() {},
  computed: {
    activeNavItem() {
      return this.$store.getters["account/current"].page;
    },
    navItems() {
      return [
        { id: "profile-details", label: "Your Details" },
        { id: "profile-company", label: "Company" },
        { id: "profile-payment", label: "Get Paid" },
        { id: "profile-complete", label: "Finish Line" },
      ];
    },
  },
  methods: {
    changePage(which) {
      this.$store.commit("account/navigateTo", {
        pane: this.id,
        page: which.id,
      });
    },
  },
};
</script>
